(function () {
  'use strict';

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 40) {
        clearInterval(timer);
      }
    }, 50);
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  function buildGymSetImageMap() {
    var map = {};
    document.querySelectorAll('[data-ns-gym-set-card]').forEach(function (card) {
      var handle = card.getAttribute('data-product-handle');
      var imageUrl = card.getAttribute('data-card-image');
      if (!imageUrl) {
        var img = card.querySelector('.ns-gym-set__card-img');
        if (img) imageUrl = img.currentSrc || img.src;
      }
      if (handle && imageUrl) map[handle] = imageUrl;
    });
    return map;
  }

  function getLineImage(item, gymSetImages) {
    if (!item) return '';
    var handle = item.handle || '';
    if (handle && gymSetImages[handle]) return gymSetImages[handle];
    return item.image || '';
  }

  var nasalStripsCart = {
    discountCode: '',
    listeners: [],
    pageActivated: false,

    activate: function () {
      this.pageActivated = true;
    },

    setDiscountCode: function (code) {
      this.discountCode = code || '';
    },

    onChange: function (fn) {
      if (typeof fn === 'function') this.listeners.push(fn);
    },

    notify: function (cart) {
      this.listeners.forEach(function (fn) {
        try {
          fn(cart);
        } catch (e) {
          /* noop */
        }
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    },

    fetchCart: function () {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
        return res.json();
      });
    },

    refresh: function () {
      var self = this;
      return this.fetchCart().then(function (cart) {
        self.notify(cart);
        return cart;
      });
    },

    addItems: function (items) {
      var self = this;
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (!data.status) self.activate();
          return data;
        });
    },

    updateLineQuantity: function (lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: lineKey, quantity: Math.max(0, parseInt(quantity, 10) || 0) }),
      }).then(function (res) {
        return res.json();
      });
    },
  };

  function formatProductCount(count) {
    var n = Number(count || 0);
    return n === 1 ? '1 Product' : n + ' Products';
  }

  function getLineVariantLabel(item) {
    if (!item) return '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }
    if (item.options_with_values && item.options_with_values.length) {
      return item.options_with_values
        .map(function (opt) {
          return opt.name + ': ' + opt.value;
        })
        .join(' | ');
    }
    return '';
  }

  function initStickyCart() {
    if (!document.body.classList.contains('frido-nasal-strips-fitness-page')) return;

    var stickyCart = document.querySelector('[data-ns-sticky-cart]');
    if (!stickyCart || stickyCart.dataset.nsStickyCartInit === 'true') return;
    stickyCart.dataset.nsStickyCartInit = 'true';

    if (stickyCart.parentElement !== document.body) {
      document.body.appendChild(stickyCart);
    }

    var itemsPanel = stickyCart.querySelector('[data-ns-sticky-cart-items]');
    var listEl = stickyCart.querySelector('[data-ns-sticky-cart-list]');
    var countEl = stickyCart.querySelector('[data-ns-sticky-cart-count]');
    var thumbsEl = stickyCart.querySelector('[data-ns-sticky-cart-thumbs]');
    var totalEl = stickyCart.querySelector('[data-ns-sticky-cart-total]');
    var compareEl = stickyCart.querySelector('[data-ns-sticky-cart-compare]');
    var offerEl = stickyCart.querySelector('[data-ns-sticky-cart-offer]');
    var offerTextEl = stickyCart.querySelector('[data-ns-sticky-cart-offer-text]');
    var toggleBtn = stickyCart.querySelector('[data-ns-sticky-cart-toggle]');
    var buyBtn = stickyCart.querySelector('[data-ns-sticky-cart-buy]');
    var isExpanded = false;
    var gymSetImages = buildGymSetImageMap();

    function setBuyLoading(loading) {
      if (!buyBtn) return;
      buyBtn.classList.toggle('is-loading', !!loading);
      buyBtn.disabled = !!loading;
    }

    function setQtyLoading(qtyEl, loading) {
      if (!qtyEl) return;
      qtyEl.classList.toggle('is-loading', !!loading);
      qtyEl.querySelectorAll('button').forEach(function (btn) {
        btn.disabled = !!loading;
      });
    }

    function syncStickyHeight() {
      var h = stickyCart.offsetHeight || 0;
      document.documentElement.style.setProperty('--ns-sticky-cart-h', h + 'px');
    }

    function setExpanded(expanded) {
      isExpanded = !!expanded;
      stickyCart.classList.toggle('is-expanded', isExpanded);
      if (itemsPanel) itemsPanel.hidden = !isExpanded;
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      window.requestAnimationFrame(syncStickyHeight);
    }

    function renderThumbs(items) {
      if (!thumbsEl) return;
      thumbsEl.innerHTML = '';
      (items || []).slice(0, 4).forEach(function (item) {
        var thumb = document.createElement('span');
        thumb.className = 'ns-sticky-cart__thumb';
        var imageSrc = getLineImage(item, gymSetImages);
        if (imageSrc) {
          var img = document.createElement('img');
          img.src = imageSrc;
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          thumb.appendChild(img);
        }
        thumbsEl.appendChild(thumb);
      });
    }

    function renderLineItems(items) {
      if (!listEl) return;
      listEl.innerHTML = '';

      (items || []).forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'ns-sticky-cart__line';
        li.setAttribute('data-line-key', item.key);
        li.setAttribute('data-quantity', String(item.quantity));

        var media = document.createElement('div');
        media.className = 'ns-sticky-cart__line-media';
        var imageSrc = getLineImage(item, gymSetImages);
        if (imageSrc) {
          var img = document.createElement('img');
          img.src = imageSrc;
          img.alt = item.product_title || item.title || '';
          img.loading = 'lazy';
          img.decoding = 'async';
          media.appendChild(img);
        }

        var body = document.createElement('div');
        body.className = 'ns-sticky-cart__line-body';

        var title = document.createElement('p');
        title.className = 'ns-sticky-cart__line-title';
        title.textContent = item.product_title || item.title || 'Product';

        var price = document.createElement('p');
        price.className = 'ns-sticky-cart__line-price';
        if (item.quantity > 1) {
          price.textContent = formatMoney(item.price) + ' each';
        } else {
          price.textContent = formatMoney(item.price);
        }

        body.appendChild(title);
        body.appendChild(price);

        var variantLabel = getLineVariantLabel(item);
        if (variantLabel) {
          var meta = document.createElement('p');
          meta.className = 'ns-sticky-cart__line-meta';
          meta.textContent = variantLabel;
          body.appendChild(meta);
        }

        var actions = document.createElement('div');
        actions.className = 'ns-sticky-cart__line-actions';

        var qtyEl = document.createElement('div');
        qtyEl.className = 'ns-sticky-cart__qty';
        qtyEl.setAttribute('data-line-key', item.key);

        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'ns-sticky-cart__qty-btn';
        minusBtn.setAttribute('data-ns-sticky-cart-qty-delta', '-1');
        minusBtn.setAttribute('data-line-key', item.key);
        minusBtn.setAttribute(
          'aria-label',
          item.quantity === 1 ? 'Remove from cart' : 'Decrease quantity'
        );
        minusBtn.textContent = '−';
        qtyEl.appendChild(minusBtn);

        var qtyValue = document.createElement('span');
        qtyValue.className = 'ns-sticky-cart__qty-value';
        qtyValue.textContent = String(item.quantity);
        qtyEl.appendChild(qtyValue);

        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'ns-sticky-cart__qty-btn';
        plusBtn.setAttribute('data-ns-sticky-cart-qty-delta', '1');
        plusBtn.setAttribute('data-line-key', item.key);
        plusBtn.setAttribute('aria-label', 'Increase quantity');
        plusBtn.textContent = '+';
        qtyEl.appendChild(plusBtn);

        var qtyIndicator = document.createElement('span');
        qtyIndicator.className = 'ns-sticky-cart__qty-indicator';
        qtyIndicator.setAttribute('aria-hidden', 'true');
        qtyEl.appendChild(qtyIndicator);

        actions.appendChild(qtyEl);

        li.appendChild(media);
        li.appendChild(body);
        li.appendChild(actions);
        listEl.appendChild(li);
      });
    }

    function renderCart(cart) {
      gymSetImages = buildGymSetImageMap();

      if (!nasalStripsCart.pageActivated) {
        stickyCart.hidden = true;
        stickyCart.setAttribute('aria-hidden', 'true');
        stickyCart.classList.remove('is-visible');
        document.body.classList.remove('ns-has-sticky-cart');
        return;
      }

      var items = cart && cart.items ? cart.items : [];
      var itemCount = cart ? cart.item_count || 0 : 0;
      var hasItems = itemCount > 0;
      var originalTotal = 0;

      items.forEach(function (item) {
        originalTotal += Number(item.original_line_price || item.line_price || 0);
      });

      var savings = Math.max(0, originalTotal - Number(cart ? cart.total_price : 0));

      if (countEl) countEl.textContent = formatProductCount(itemCount);
      if (totalEl) totalEl.textContent = formatMoney(cart ? cart.total_price : 0);

      if (compareEl) {
        if (savings > 0) {
          compareEl.textContent = formatMoney(originalTotal);
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }

      if (offerEl && offerTextEl) {
        if (savings > 0) {
          offerTextEl.textContent = "Congrats! Offer unlocked — you're saving " + formatMoney(savings);
          offerEl.hidden = false;
        } else {
          offerTextEl.textContent = '';
          offerEl.hidden = true;
        }
      }

      renderLineItems(items);
      renderThumbs(items);

      stickyCart.hidden = !hasItems;
      stickyCart.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
      stickyCart.classList.toggle('is-visible', hasItems);
      document.body.classList.toggle('ns-has-sticky-cart', hasItems);

      if (!hasItems) {
        setExpanded(false);
      }

      window.requestAnimationFrame(syncStickyHeight);
    }

    function checkoutFromStickyCart() {
      setBuyLoading(true);

      nasalStripsCart.fetchCart().then(function (cart) {
        if (!cart || !cart.item_count) {
          setBuyLoading(false);
          return;
        }

        var discountCode = nasalStripsCart.discountCode || '';
        var fallbackUrl = '/checkout';

        if (
          window.FridoPdpGokwikCheckout &&
          window.FridoPdpGokwikCheckout.shouldUseGokwik &&
          window.FridoPdpGokwikCheckout.shouldUseGokwik() &&
          window.FridoPdpGokwikCheckout.checkoutFromCart
        ) {
          window.FridoPdpGokwikCheckout.checkoutFromCart({
            uiButton: buyBtn,
            discountCode: discountCode,
            fallbackUrl: fallbackUrl,
            onComplete: function () {
              setBuyLoading(false);
            },
            onError: function () {
              setBuyLoading(false);
            },
          });
          return;
        }

        window.location.href = fallbackUrl;
      });
    }

    nasalStripsCart.onChange(renderCart);

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setExpanded(!isExpanded);
      });
    }

    if (listEl) {
      listEl.addEventListener('click', function (event) {
        var qtyBtn = event.target.closest('[data-ns-sticky-cart-qty-delta]');
        if (qtyBtn && !qtyBtn.disabled) {
          var qtyLineKey = qtyBtn.getAttribute('data-line-key');
          var delta = parseInt(qtyBtn.getAttribute('data-ns-sticky-cart-qty-delta'), 10) || 0;
          var lineEl = qtyBtn.closest('.ns-sticky-cart__line');
          var qtyEl = qtyBtn.closest('.ns-sticky-cart__qty');
          if (!qtyLineKey || !lineEl || !delta) return;

          var currentQty = parseInt(lineEl.getAttribute('data-quantity') || '1', 10) || 1;
          var nextQty = currentQty + delta;
          if (nextQty < 0 || nextQty > 99) return;

          setQtyLoading(qtyEl, true);
          nasalStripsCart
            .updateLineQuantity(qtyLineKey, nextQty)
            .then(function (data) {
              if (data.status) throw data;
              return nasalStripsCart.refresh();
            })
            .catch(function () {
              setQtyLoading(qtyEl, false);
            });
        }
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', checkoutFromStickyCart);
    }

    window.addEventListener('resize', syncStickyHeight);
    window.FridoNasalStripsCart = nasalStripsCart;
  }

  function formatPerStrip(priceCents, stripCount) {
    var strips = Number(stripCount || 0);
    if (!strips) return '';
    var perStrip = Number(priceCents || 0) / 100 / strips;
    return '₹' + perStrip.toFixed(2) + ' / strip';
  }

  function initTopChrome() {
    if (!document.body.classList.contains('frido-nasal-strips-fitness-page')) return;

    var gallery = document.getElementById('nsGallery');
    if (!gallery || gallery.dataset.nsTopChromeInit === 'true') return;

    var siteHdr = gallery.querySelector('[data-ns-site-hdr]');
    var marquee = gallery.querySelector('[data-ns-gallery-marquee]');
    if (!siteHdr && !marquee) return;

    gallery.dataset.nsTopChromeInit = 'true';

    var chrome = document.createElement('div');
    chrome.className = 'ns-top-chrome';
    chrome.setAttribute('data-ns-top-chrome', '');

    var marqueeBar = document.createElement('div');
    marqueeBar.className = 'ns-fitness-marquee-bar';
    marqueeBar.setAttribute('data-ns-fitness-marquee-bar', '');

    var galleryMarqueeAnchor = gallery.querySelector('[data-ns-gallery-zoom]') || null;
    var marqueePlaceholder = document.createComment('ns-marquee-placeholder');

    if (marquee) {
      marquee.parentNode.insertBefore(marqueePlaceholder, marquee);
    }

    if (siteHdr && siteHdr.parentElement !== chrome) {
      chrome.appendChild(siteHdr);
    }

    if (chrome.parentElement !== document.body) {
      document.body.insertBefore(chrome, document.body.firstChild);
    }

    function syncTopChromeHeight() {
      var navH = siteHdr ? siteHdr.offsetHeight : 0;
      var marqueeH =
        marquee &&
        window.matchMedia('(min-width: 990px)').matches &&
        marqueeBar.contains(marquee)
          ? marqueeBar.offsetHeight
          : 0;
      var totalH = navH + marqueeH;

      document.documentElement.style.setProperty('--ns-nav-h', navH + 'px');
      document.documentElement.style.setProperty('--ns-marquee-h', marqueeH + 'px');
      document.documentElement.style.setProperty('--ns-top-chrome-h', totalH + 'px');
    }

    function mountDesktopMarquee() {
      if (!marquee) return;

      if (marquee.parentElement !== marqueeBar) {
        marqueeBar.appendChild(marquee);
      }

      if (marqueeBar.parentElement !== chrome) {
        chrome.appendChild(marqueeBar);
      }

      syncTopChromeHeight();
    }

    function mountMobileMarquee() {
      if (!marquee) return;

      if (marquee.parentElement === marqueeBar) {
        if (galleryMarqueeAnchor) {
          gallery.insertBefore(marquee, galleryMarqueeAnchor);
        } else {
          gallery.appendChild(marquee);
        }
      }

      if (marqueeBar.isConnected) {
        marqueeBar.remove();
      }

      syncTopChromeHeight();
    }

    function updateTopChromePlacement() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        mountDesktopMarquee();
      } else {
        mountMobileMarquee();
      }
    }

    updateTopChromePlacement();
    window.addEventListener('resize', updateTopChromePlacement);

    if (typeof ResizeObserver !== 'undefined') {
      var chromeResizeObserver = new ResizeObserver(syncTopChromeHeight);
      if (siteHdr) chromeResizeObserver.observe(siteHdr);
      if (marqueeBar) chromeResizeObserver.observe(marqueeBar);
    }
  }

  function initFoldLayout() {
    if (!document.body.classList.contains('frido-nasal-strips-fitness-page')) return;

    var page = document.getElementById('PageContainer') || document.querySelector('main')  /* the layout this page was written against gave <main> the id PageContainer; this theme's main is #MainContent, so fall back to the element rather than the id */;
    if (!page || page.querySelector('.ns-fitness-fold')) return;

    var gallerySection = page.querySelector(
      '.shopify-section:has([data-frido-nasal-strips-fitness-fold-item="gallery"])'
    );
    var buySection = page.querySelector(
      '.shopify-section:has([data-frido-nasal-strips-fitness-fold-item="buy"])'
    );
    var belowFold = page.querySelector('.shopify-section:has(#nsBottom)');
    if (!gallerySection || !buySection || !belowFold) return;

    var fold = document.createElement('div');
    fold.className = 'ns-fitness-fold';
    fold.setAttribute('data-frido-nasal-strips-fitness-fold', '');

    var mediaCol = document.createElement('div');
    mediaCol.className = 'ns-fitness-fold__media';

    var mainCol = document.createElement('div');
    mainCol.className = 'ns-fitness-fold__main';

    mediaCol.appendChild(gallerySection);
    mainCol.appendChild(buySection);

    fold.appendChild(mediaCol);
    fold.appendChild(mainCol);
    belowFold.parentNode.insertBefore(fold, belowFold);
  }

  function initFoldBuyColumn() {
    if (!document.body.classList.contains('frido-nasal-strips-fitness-page')) return;

    var buyInner = document.querySelector('#nsBuyBox .ns-buy__inner');
    if (!buyInner || buyInner.dataset.nsFoldBuyColumnInit === 'true') return;

    var accordionSlot = document.querySelector('[data-ns-bottom-accordion-slot]');
    var trustSlot = document.querySelector('[data-ns-bottom-trust-slot]');
    var accordion = document.querySelector('[data-ns-accordion]');
    var trust = document.querySelector('#nsBottom .ns-trust');

    if (!accordion && !trust) return;
    buyInner.dataset.nsFoldBuyColumnInit = 'true';

    var extrasHost = buyInner.querySelector('[data-ns-buy-fold-extras]');
    if (!extrasHost) {
      extrasHost = document.createElement('div');
      extrasHost.className = 'ns-buy__fold-extras';
      extrasHost.setAttribute('data-ns-buy-fold-extras', '');
      buyInner.appendChild(extrasHost);
    }

    function mountDesktopBuyColumn() {
      if (!document.querySelector('.ns-fitness-fold')) {
        mountMobileBuyColumn();
        return;
      }

      if (accordion) {
        extrasHost.appendChild(accordion);
        accordion.classList.add('ns-accordion--in-buy');
      }

      if (trust) {
        extrasHost.appendChild(trust);
        trust.classList.add('ns-trust--in-buy');
      }
    }

    function mountMobileBuyColumn() {
      if (trust && trustSlot) {
        trustSlot.appendChild(trust);
        trust.classList.remove('ns-trust--in-buy');
      }

      if (accordion && accordionSlot) {
        accordionSlot.appendChild(accordion);
        accordion.classList.remove('ns-accordion--in-buy');
      }
    }

    function updateBuyColumnPlacement() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        mountDesktopBuyColumn();
      } else {
        mountMobileBuyColumn();
      }
    }

    updateBuyColumnPlacement();
    window.addEventListener('resize', updateBuyColumnPlacement);
  }

  function initGallery() {
    var gallery = document.getElementById('nsGallery');
    if (!gallery || gallery.dataset.nsGalleryInit === 'true') return;

    var mainEl = gallery.querySelector('[data-ns-gallery-main]');
    var thumbsEl = gallery.querySelector('[data-ns-gallery-thumbs]');
    if (!mainEl) return;

    gallery.dataset.nsGalleryInit = 'true';

    function mountGallerySwipers() {
      if (gallery._nsMainSwiper && !gallery._nsMainSwiper.destroyed) {
        gallery._nsMainSwiper.destroy(true, true);
      }
      if (gallery._nsThumbsSwiper && !gallery._nsThumbsSwiper.destroyed) {
        gallery._nsThumbsSwiper.destroy(true, true);
      }

      var thumbSlides = thumbsEl ? thumbsEl.querySelectorAll('.swiper-slide') : [];
      var thumbsSwiper = null;

      if (thumbsEl && thumbSlides.length > 1) {
        thumbsSwiper = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
        });
        gallery._nsThumbsSwiper = thumbsSwiper;
      }

      var mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        thumbs: thumbsSwiper
          ? {
              swiper: thumbsSwiper,
              slideThumbActiveClass: 'swiper-slide-thumb-active',
            }
          : undefined,
      });
      gallery._nsMainSwiper = mainSwiper;

      function syncThumbActive(index) {
        if (!thumbsEl) return;
        thumbSlides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
      }

      syncThumbActive(mainSwiper.activeIndex);
      mainSwiper.on('slideChange', function () {
        syncThumbActive(mainSwiper.activeIndex);
      });

      if (thumbsEl && thumbSlides.length) {
        thumbSlides.forEach(function (slide, index) {
          slide.addEventListener('click', function () {
            mainSwiper.slideTo(index);
            syncThumbActive(index);
          });
        });
      }

      bindGalleryZoom(gallery, mainSwiper);
    }

    function bindGalleryZoom(gallery, mainSwiper) {
      if (gallery._nsZoomBound) return;
      gallery._nsZoomBound = true;

      var zoomOverlay = gallery.querySelector('[data-ns-gallery-zoom]');
      var zoomImg = gallery.querySelector('[data-ns-gallery-zoom-img]');
      var zoomClose = gallery.querySelector('[data-ns-gallery-zoom-close]');
      var zoomOpen = gallery.querySelector('[data-ns-gallery-zoom-open]');

      function openZoom() {
        var swiper = gallery._nsMainSwiper || mainSwiper;
        var slide = swiper.slides[swiper.activeIndex];
        if (!slide || !zoomOverlay || !zoomImg) return;
        var img = slide.querySelector('.ns-gallery__img');
        if (!img) return;
        var src = img.getAttribute('data-ns-zoom-src') || img.currentSrc || img.src;
        zoomImg.src = src;
        zoomImg.alt = img.alt || '';
        zoomOverlay.hidden = false;
        zoomOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      function closeZoom() {
        if (!zoomOverlay) return;
        zoomOverlay.hidden = true;
        zoomOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      if (zoomOpen) zoomOpen.addEventListener('click', openZoom);
      if (zoomClose) zoomClose.addEventListener('click', closeZoom);
      if (zoomOverlay) {
        zoomOverlay.addEventListener('click', function (e) {
          if (e.target === zoomOverlay) closeZoom();
        });
      }

      gallery.querySelectorAll('.ns-gallery__img').forEach(function (img) {
        img.addEventListener('click', openZoom);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeZoom();
      });
    }

    whenSwiperReady(mountGallerySwipers);
  }

  function initBuyBox() {
    var buyBox = document.getElementById('nsBuyBox');
    var dataNode = document.getElementById('nsProductData');
    if (!buyBox || !dataNode) return;

    var productData = {};
    try {
      productData = JSON.parse(dataNode.textContent);
    } catch (e) {
      return;
    }

    var packButtons = Array.prototype.slice.call(buyBox.querySelectorAll('[data-ns-pack]'));
    var buyBtn = buyBox.querySelector('[data-ns-buy-now]');
    var subscribeBtn = buyBox.querySelector('[data-ns-subscribe-select]');
    var subscribeDetail = buyBox.querySelector('[data-ns-subscribe-detail]');
    var packHeadMeta = buyBox.querySelector('[data-ns-pack-head-meta]');
    var priceSale = buyBox.querySelector('[data-ns-price-sale]');
    var priceCompare = buyBox.querySelector('[data-ns-price-compare]');
    var priceSave = buyBox.querySelector('[data-ns-price-save]');
    var qtyValue = buyBox.querySelector('[data-ns-qty-value]');
    var qtyMinus = buyBox.querySelector('[data-ns-qty-minus]');
    var qtyPlus = buyBox.querySelector('[data-ns-qty-plus]');

    if (!packButtons.length) return;

    var quantity = 1;
    var selectedPack = packButtons.find(function (btn) {
      return btn.classList.contains('is-selected');
    }) || packButtons[productData.defaultPackIndex || 0] || packButtons[0];

    function updatePackPerStripLabels(activeBtn) {
      packButtons.forEach(function (pack) {
        var perStripEl = pack.querySelector('[data-ns-pack-per-strip]');
        if (!perStripEl) return;
        if (pack.getAttribute('data-show-per-strip') !== 'true') {
          perStripEl.textContent = '';
          return;
        }
        perStripEl.textContent = formatPerStrip(
          pack.getAttribute('data-price-cents'),
          pack.getAttribute('data-strip-count')
        );
      });
    }

    function updatePackHeadMeta(btn) {
      if (!packHeadMeta || !btn) return;
      var subtitle = btn.getAttribute('data-pack-subtitle') || '';
      if (btn.getAttribute('data-show-per-strip') === 'true') {
        var perStrip = formatPerStrip(btn.getAttribute('data-price-cents'), btn.getAttribute('data-strip-count'));
        packHeadMeta.textContent = perStrip || subtitle;
        return;
      }
      packHeadMeta.textContent = subtitle;
    }

    function updateSubscribeDetail(btn) {
      if (!subscribeDetail || !btn) return;
      var detail = btn.getAttribute('data-subscribe-detail');
      if (detail) subscribeDetail.textContent = detail;
    }

    function updatePriceFromPack(btn) {
      if (!btn) return;
      var priceCents = Number(btn.getAttribute('data-price-cents') || 0);
      var compareCents = Number(btn.getAttribute('data-compare-cents') || 0);
      var discountPercent = Number(btn.getAttribute('data-discount-percent') || 0);

      if (priceSale) priceSale.textContent = formatMoney(priceCents);

      if (priceCompare) {
        if (compareCents > priceCents) {
          priceCompare.textContent = formatMoney(compareCents);
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }

      if (priceSave) {
        if (discountPercent > 0) {
          priceSave.textContent = 'Save ' + discountPercent + '%';
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }
    }

    function selectPack(btn) {
      if (!btn) return;
      selectedPack = btn;
      packButtons.forEach(function (pack) {
        pack.classList.toggle('is-selected', pack === btn);
      });
      updatePriceFromPack(btn);
      updatePackHeadMeta(btn);
      updatePackPerStripLabels(btn);
      if (btn.getAttribute('data-is-subscribe') === 'true') {
        updateSubscribeDetail(btn);
      }
    }

    function getPackCartQuantity(btn) {
      return Math.max(1, parseInt(btn.getAttribute('data-cart-quantity') || '1', 10) || 1);
    }

    function setQuantity(nextQty) {
      quantity = Math.max(1, Math.min(99, parseInt(nextQty, 10) || 1));
      if (qtyValue) qtyValue.textContent = String(quantity);
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        setQuantity(quantity - 1);
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        setQuantity(quantity + 1);
      });
    }
    setQuantity(1);

    packButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectPack(btn);
      });
    });

    if (subscribeBtn) {
      subscribeBtn.addEventListener('click', function () {
        var subscribePack = packButtons.find(function (btn) {
          return btn.getAttribute('data-is-subscribe') === 'true';
        });
        if (subscribePack) selectPack(subscribePack);
      });
    }

    selectPack(selectedPack);

    function setLoading(loading) {
      if (!buyBtn) return;
      buyBtn.classList.toggle('is-loading', !!loading);
      buyBtn.disabled = !!loading;
    }

    function addSelectedPackToCart() {
      var variantId = parseInt(selectedPack.getAttribute('data-variant-id'), 10);
      var packQty = getPackCartQuantity(selectedPack);
      var discountCode = selectedPack.getAttribute('data-discount-code') || '';

      if (!variantId) {
        alert('This pack is not available yet. Please try another option.');
        return;
      }

      setLoading(true);

      nasalStripsCart
        .addItems([{ id: variantId, quantity: packQty }])
        .then(function (data) {
          if (data.status) throw data;
          if (discountCode) nasalStripsCart.setDiscountCode(discountCode);
          else nasalStripsCart.setDiscountCode('');
          return nasalStripsCart.refresh();
        })
        .catch(function () {
          alert('Could not add to cart. Please try again.');
        })
        .then(function () {
          setLoading(false);
        });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', addSelectedPackToCart);
    }

    window.FridoNasalStripsBuyBox = {
      selectPackByKey: function (packKey) {
        if (!packKey) return false;
        var match = packButtons.find(function (btn) {
          return btn.getAttribute('data-pack-key') === packKey;
        });
        if (!match) return false;
        selectPack(match);
        return true;
      },
      scrollToBuyBox: function () {
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      },
      addToCart: addSelectedPackToCart,
      checkout: addSelectedPackToCart,
    };
  }

  function initGymSet() {
    var root = document.querySelector('[data-ns-gym-set]');
    if (!root || root.dataset.nsGymSetInit === 'true') return;
    root.dataset.nsGymSetInit = 'true';

    var catalogNode = root.querySelector('[data-ns-gym-set-catalog]');
    var modal = root.querySelector('[data-ns-gym-set-modal]');
    var modalTitle = root.querySelector('[data-ns-gym-set-modal-title]');
    var modalOptions = root.querySelector('[data-ns-gym-set-modal-options]');
    var modalSale = root.querySelector('[data-ns-gym-set-modal-sale]');
    var modalCompare = root.querySelector('[data-ns-gym-set-modal-compare]');
    var modalConfirm = root.querySelector('[data-ns-gym-set-modal-confirm]');
    var catalog = [];

    if (catalogNode) {
      try {
        catalog = JSON.parse(catalogNode.textContent);
      } catch (e) {
        catalog = [];
      }
    }

    var catalogByHandle = {};
    catalog.forEach(function (product) {
      if (product && product.handle) catalogByHandle[product.handle] = product;
    });

    var activeProduct = null;
    var selectedOptions = [];
    var activeTriggerBtn = null;

    function findProduct(handle) {
      return catalogByHandle[handle] || null;
    }

    function needsVariantPicker(product) {
      if (!product) return false;
      if (product.has_only_default_variant) return false;
      return (product.variants || []).length > 1;
    }

    function getVariantOptionValue(variant, index) {
      if (!variant) return '';
      if (index === 0) return variant.option1 || '';
      if (index === 1) return variant.option2 || '';
      return variant.option3 || '';
    }

    function isColorOptionName(name) {
      return /colou?r|shade/i.test(String(name || ''));
    }

    function normalizeColorKey(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function getSwatchHex(colorValue) {
      var key = normalizeColorKey(colorValue);
      if (!key) return '#6a757c';
      if (key.indexOf('black') !== -1) return '#0b0b0b';
      if (key.indexOf('white') !== -1) return '#f5f5f5';
      if (key.indexOf('grey') !== -1 || key.indexOf('gray') !== -1) return '#6a757c';
      if (key.indexOf('red') !== -1) return '#c62828';
      if (key.indexOf('blue') !== -1) return '#2a5e7e';
      if (key.indexOf('green') !== -1) return '#4b5c09';
      if (key.indexOf('pink') !== -1) return '#ffb6c1';
      if (key.indexOf('wine') !== -1) return '#752b48';
      if (key.indexOf('olive') !== -1) return '#4b5c09';
      if (key.indexOf('navy') !== -1) return '#1a2744';
      if (key.indexOf('beige') !== -1 || key.indexOf('tan') !== -1) return '#c4a882';
      return '#6a757c';
    }

    function getVariantImageForOption(product, optIdx, value) {
      var variants = product.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (String(getVariantOptionValue(variants[i], optIdx) || '') !== String(value)) continue;
        if (variants[i].featured_image && variants[i].featured_image.src) {
          return variants[i].featured_image.src;
        }
      }
      if (product.featured_image) return product.featured_image;
      if (product.images && product.images.length) return product.images[0];
      return '';
    }

    function getAvailableValues(product, optionIndex, currentSelection) {
      var valueMap = {};

      (product.variants || []).forEach(function (variant) {
        var matches = true;
        var i;
        for (i = 0; i < optionIndex; i++) {
          if (currentSelection[i] && getVariantOptionValue(variant, i) !== currentSelection[i]) {
            matches = false;
            break;
          }
        }
        if (!matches) return;

        var value = getVariantOptionValue(variant, optionIndex);
        if (!value) return;

        if (!valueMap[value]) {
          valueMap[value] = {
            value: value,
            available: false,
          };
        }
        if (variant.available) {
          valueMap[value].available = true;
        }
      });

      return Object.keys(valueMap).map(function (key) {
        return valueMap[key];
      });
    }

    function findSelectedVariant(product, options) {
      var variants = product.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        var variant = variants[i];
        if (
          (!options[0] || variant.option1 === options[0]) &&
          (!options[1] || variant.option2 === options[1]) &&
          (!options[2] || variant.option3 === options[2])
        ) {
          return variant;
        }
      }
      return variants[0] || null;
    }

    function getFirstAvailableVariant(product) {
      var variants = product.variants || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].available) return variants[i];
      }
      return variants[0] || null;
    }

    function syncModalPricing(variant) {
      if (!variant) return;
      if (modalSale) modalSale.textContent = formatMoney(variant.price);
      if (modalCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          modalCompare.textContent = formatMoney(variant.compare_at_price);
          modalCompare.hidden = false;
        } else {
          modalCompare.textContent = '';
          modalCompare.hidden = true;
        }
      }
      if (modalConfirm) modalConfirm.disabled = !variant.available;
    }

    function renderModalOptions() {
      if (!modalOptions || !activeProduct) return;

      modalOptions.innerHTML = '';
      var options = activeProduct.options || [];

      options.forEach(function (optionName, optionIndex) {
        if (!optionName || optionName === 'Title') return;

        var row = document.createElement('div');
        row.className = 'ns-gym-set-modal__option';

        var label = document.createElement('p');
        label.className = 'ns-gym-set-modal__option-label';
        label.textContent = optionName;
        row.appendChild(label);

        var valuesWrap = document.createElement('div');
        valuesWrap.className = 'ns-gym-set-modal__values';
        if (isColorOptionName(optionName)) {
          valuesWrap.classList.add('ns-gym-set-modal__values--swatches');
        }

        getAvailableValues(activeProduct, optionIndex, selectedOptions).forEach(function (entry) {
          var btn = document.createElement('button');
          btn.type = 'button';

          if (isColorOptionName(optionName)) {
            btn.className = 'ns-gym-set-modal__swatch';
            btn.setAttribute('aria-label', entry.value + (entry.available ? '' : ' (unavailable)'));

            if (selectedOptions[optionIndex] === entry.value) {
              btn.classList.add('is-selected');
              btn.setAttribute('aria-pressed', 'true');
            } else {
              btn.setAttribute('aria-pressed', 'false');
            }

            if (!entry.available) {
              btn.classList.add('is-unavailable');
            }

            var inner = document.createElement('span');
            inner.className = 'ns-gym-set-modal__swatch-inner';
            var imgSrc = getVariantImageForOption(activeProduct, optionIndex, entry.value);
            if (imgSrc) {
              var img = document.createElement('img');
              img.src = imgSrc;
              img.alt = '';
              img.loading = 'lazy';
              img.decoding = 'async';
              inner.appendChild(img);
            } else {
              inner.style.setProperty('--ns-gym-swatch-color', getSwatchHex(entry.value));
              inner.style.background = getSwatchHex(entry.value);
            }
            btn.appendChild(inner);
          } else {
            btn.className = 'ns-gym-set-modal__value';
            btn.textContent = entry.value;

            if (selectedOptions[optionIndex] === entry.value) {
              btn.classList.add('is-selected');
              btn.setAttribute('aria-pressed', 'true');
            } else {
              btn.setAttribute('aria-pressed', 'false');
            }

            if (!entry.available) {
              btn.classList.add('is-unavailable');
            }
          }

          btn.addEventListener('click', function () {
            if (!entry.available) return;
            selectedOptions[optionIndex] = entry.value;
            renderModalOptions();
            syncModalPricing(findSelectedVariant(activeProduct, selectedOptions));
          });

          valuesWrap.appendChild(btn);
        });

        row.appendChild(valuesWrap);
        modalOptions.appendChild(row);
      });

      syncModalPricing(findSelectedVariant(activeProduct, selectedOptions));
    }

    function openModal(product, triggerBtn) {
      if (!modal || !product) return;
      activeProduct = product;
      activeTriggerBtn = triggerBtn || null;

      var firstVariant = getFirstAvailableVariant(product);
      selectedOptions = [
        getVariantOptionValue(firstVariant, 0),
        getVariantOptionValue(firstVariant, 1),
        getVariantOptionValue(firstVariant, 2),
      ];

      if (modalTitle) modalTitle.textContent = product.title;
      renderModalOptions();

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
      document.body.classList.add('ns-gym-set-modal-open');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ns-gym-set-modal-open');
      if (modalConfirm) {
        modalConfirm.classList.remove('is-loading');
        modalConfirm.disabled = false;
      }
      window.setTimeout(function () {
        if (!modal.classList.contains('is-open')) {
          modal.hidden = true;
        }
      }, 280);
      activeProduct = null;
      activeTriggerBtn = null;
    }

    function markButtonAdded(btn) {
      if (!btn) return;
      var original = btn.textContent;
      btn.textContent = 'ADDED';
      window.setTimeout(function () {
        btn.textContent = original;
      }, 1400);
    }

    function addToCart(variantId, triggerBtn, done) {
      if (!variantId) return;

      nasalStripsCart
        .addItems([{ id: Number(variantId), quantity: 1 }])
        .then(function (data) {
          if (data.status) throw data;
          markButtonAdded(triggerBtn);
          return nasalStripsCart.refresh();
        })
        .then(function () {
          if (done) done();
        })
        .catch(function () {
          if (triggerBtn) triggerBtn.disabled = false;
          if (modalConfirm) {
            modalConfirm.classList.remove('is-loading');
            modalConfirm.disabled = false;
          }
        });
    }

    root.querySelectorAll('[data-ns-gym-set-card]').forEach(function (card) {
      var handle = card.getAttribute('data-product-handle');
      var product = findProduct(handle);
      var addBtn = card.querySelector('[data-ns-gym-set-add]');
      if (!product || !addBtn) return;

      addBtn.addEventListener('click', function () {
        if (needsVariantPicker(product)) {
          openModal(product, addBtn);
          return;
        }

        var variant = getFirstAvailableVariant(product);
        if (!variant || !variant.available) return;
        addBtn.disabled = true;
        addToCart(variant.id, addBtn, function () {
          addBtn.disabled = false;
        });
      });
    });

    if (modal) {
      modal.querySelectorAll('[data-ns-gym-set-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });

      if (modalConfirm) {
        modalConfirm.addEventListener('click', function () {
          if (!activeProduct) return;
          var variant = findSelectedVariant(activeProduct, selectedOptions);
          if (!variant || !variant.available) return;

          modalConfirm.classList.add('is-loading');
          modalConfirm.disabled = true;

          addToCart(
            variant.id,
            activeTriggerBtn,
            function () {
              modalConfirm.classList.remove('is-loading');
              modalConfirm.disabled = false;
              closeModal();
            }
          );
        });
      }
    }
  }

  function initBottom() {
    var bottom = document.getElementById('nsBottom');
    if (!bottom) return;

    var accordion = document.querySelector('[data-ns-accordion]');
    if (accordion && accordion.dataset.nsAccordionInit !== 'true') {
      accordion.dataset.nsAccordionInit = 'true';
      var items = Array.prototype.slice.call(accordion.querySelectorAll('.ns-accordion__item'));

      function setItemOpen(item, open) {
        var trigger = item.querySelector('[data-ns-accordion-trigger]');
        var panel = item.querySelector('.ns-accordion__panel');
        item.classList.toggle('is-open', !!open);
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-ns-accordion-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (other) {
            if (other !== item) setItemOpen(other, false);
          });
          setItemOpen(item, willOpen);
        });
      });
    }

    var trialCta = bottom.querySelector('[data-ns-trial-cta]');
    if (trialCta && trialCta.dataset.nsTrialBound !== 'true') {
      trialCta.dataset.nsTrialBound = 'true';
      trialCta.addEventListener('click', function () {
        var packKey = trialCta.getAttribute('data-trial-pack-key') || 'trial';
        var buyApi = window.FridoNasalStripsBuyBox;
        if (!buyApi) return;

        if (buyApi.selectPackByKey(packKey)) {
          buyApi.scrollToBuyBox();
          window.setTimeout(function () {
            buyApi.addToCart();
          }, 350);
        }
      });
    }
  }

  function initAboutTabs() {
    var sections = document.querySelectorAll('[data-ns-about-tabs]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      if (section.dataset.nsAboutTabsInit === 'true') return;
      section.dataset.nsAboutTabsInit = 'true';

      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-ns-about-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-ns-about-panel]'));
      if (!tabs.length || !panels.length) return;

      function activateTab(index) {
        tabs.forEach(function (tab, i) {
          var isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel, i) {
          var isActive = i === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(index);
        });
      });
    });
  }

  function init() {
    initTopChrome();
    initFoldLayout();
    initFoldBuyColumn();
    initStickyCart();
    initQaHelpful();
    window.requestAnimationFrame(function () {
      initGallery();
      initBuyBox();
      initBottom();
      initGymSet();
      initAboutTabs();
    });
  }

  /* The Q&A "Helpful" buttons render a count from the section settings but had no behaviour,
     so a press did nothing at all. There is no backend for question votes, so the count is
     owned by the visitor: the press toggles, the displayed number moves by one from the
     authored figure, and the choice is remembered per question so it survives a reload
     rather than silently resetting. Storage failures (private mode, full quota) are ignored —
     the button still works for the session. */
  var QA_HELPFUL_STORE = 'frido-ns-qa-helpful';

  function readHelpfulState() {
    try {
      return JSON.parse(localStorage.getItem(QA_HELPFUL_STORE) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function writeHelpfulState(state) {
    try {
      localStorage.setItem(QA_HELPFUL_STORE, JSON.stringify(state));
    } catch (e) {
      /* nothing to do — the in-page state is still correct */
    }
  }

  function initQaHelpful() {
    var buttons = document.querySelectorAll('.ns-qa__like');
    if (!buttons.length) return;

    var state = readHelpfulState();

    buttons.forEach(function (btn, index) {
      var countEl = btn.querySelector('span');
      if (!countEl) return;

      var base = parseInt((countEl.textContent || '').replace(/[^\d]/g, ''), 10);
      if (isNaN(base)) base = 0;

      /* Key on the question text so the remembered vote follows the question rather than its
         position, which shifts whenever the merchant reorders or adds one. */
      var article = btn.closest('article');
      var question = article ? article.querySelector('.ns-qa__bubble--question') : null;
      var key = (question ? question.textContent.trim().slice(0, 80) : '') || 'q' + index;

      function render(pressed) {
        countEl.textContent = String(base + (pressed ? 1 : 0));
        btn.classList.toggle('is-helpful', pressed);
        btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      }

      render(state[key] === true);

      btn.addEventListener('click', function () {
        var next = btn.getAttribute('aria-pressed') !== 'true';
        render(next);
        if (next) state[key] = true;
        else delete state[key];
        writeHelpfulState(state);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
